<template>
  <div class="header">
    <div class="header__info">
      <img @dblclick="ExportExcel()" src="@/assets/Images/Global/Logo.svg" alt="" class="header__info__logo" />
      <div class="header__info__separator"></div>
      <p class="header__info__collection">
        {{
          Coleccion.GetLiteral(Language).toLowerCase() == "senna"
            ? "Sena"
            : Coleccion.GetLiteral(Language).toLowerCase()
        }}
      </p>
      <p class="header__info__configuration">
        {{
          aplicacion.tipo == "configurable"
            ? aplicacion.languageSel == "es"
              ? "Configuración Personalizada"
              : aplicacion.languageSel == "en"
                ? "Custom Configuration"
                : aplicacion.languageSel == "fr"
                  ? "Configuration Personnalisée"
                  : aplicacion.languageSel == "de"
                    ? "Benutzerdefinierte Konfiguration"
                    : aplicacion.languageSel == "it"
                      ? "Configurazione Personalizzata"
                      : ""
            : aplicacion.languageSel == "es"
              ? "Configuración Estándar"
              : aplicacion.languageSel == "en"
                ? "Standard Configuration"
                : aplicacion.languageSel == "fr"
                  ? "Configuration Standard"
                  : aplicacion.languageSel == "de"
                    ? "Standardkonfiguration"
                    : aplicacion.languageSel == "it"
                      ? "Configurazione Standard"
                      : ""
        }}
      </p>
    </div>
    <div class="header__menu">
      <div class="header__menu__option">
        <div class="header__menu__option__items" :class="{
          hidden: !Open,
        }">
          <div v-for="(Option, OptionIndex) in Options" :key="OptionIndex" class="header__menu__option__items__item"
            :class="{
              hidden:
                (Option.cod == 'Share' && privada == 'true') ||
                ((Option.cod == 'Share' || Option.cod == 'Hotspots') &&
                  SetEsError(
                    aplicacion.coleccionSel.sideSel.Live.EsError(
                      aplicacion.coleccionSel.sideSel.Live.perfil
                    )
                  )) ||
                (aplicacion.view.Live == '3d' &&
                  (Option.cod == 'Share' || Option.cod == 'Hotspots')),
            }">
            <div v-if="Option.cod == 'Share'" class="header__menu__option__items__item__option">
              <img @click="SetOption($event, Option)" @load="ResolveImage($event)"
                :src="require('@/assets/Images/' + Option.miniatura)" alt=""
                class="header__menu__option__items__item__option__image" />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[
                      Option.literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div v-else-if="Option.cod == 'DarkMode'" class="header__menu__option__items__item__option">
              <img @click="SetOption($event, Option)" @load="ResolveImage($event)" :src="require('@/assets/Images/' +
                Option.miniatura[DarkMode.Delay == true ? 1 : 0])
                " alt="" class="header__menu__option__items__item__option__image" />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[DarkMode.Delay == true ? 1 : 0].literales[
                      Option.literales[
                        DarkMode.Delay == true ? 1 : 0
                      ].literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div v-else-if="Option.cod == 'Hotspots'" class="header__menu__option__items__item__option">
              <img @click="SetOption($event, Option)" @load="ResolveImage($event)" :src="require('@/assets/Images/' +
                Option.miniatura[Hotspots.Delay == false ? 1 : 0])
                " alt="" class="header__menu__option__items__item__option__image" />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[Hotspots.Delay == false ? 1 : 0].literales[
                      Option.literales[
                        Hotspots.Delay == false ? 1 : 0
                      ].literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div v-else-if="Option.cod == 'Zoom'" class="header__menu__option__items__item__option">
              <img @click="SetOption($event, Option)" @load="ResolveImage($event)" :src="require('@/assets/Images/' +
                Option.miniatura[Zoom.Delay == true ? 1 : 0])
                " alt="" class="header__menu__option__items__item__option__image" />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[Zoom.Delay == true ? 1 : 0].literales[
                      Option.literales[
                        Zoom.Delay == true ? 1 : 0
                      ].literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
            <div v-else-if="Option.cod == 'FullScreen'" class="header__menu__option__items__item__option">
              <img @click="SetOption($event, Option)" @load="ResolveImage($event)" :src="require('@/assets/Images/' +
                Option.miniatura[FullScreen.Delay == true ? 1 : 0])
                " alt="" class="header__menu__option__items__item__option__image" />
              <div class="header__menu__option__items__item__option__name">
                <p>
                  {{
                    Option.literales[FullScreen.Delay == true ? 1 : 0]
                      .literales[
                      Option.literales[
                        FullScreen.Delay == true ? 1 : 0
                      ].literales.findIndex(
                        (Literal) => Literal.codIdioma == Language
                      )
                    ].texto
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div @click="Open = !Open" class="header__menu__option__icon hamburguer" :class="{
          open: Open,
        }">
          <div class="header__menu__option__icon__bar"></div>
          <div class="header__menu__option__icon__bar"></div>
          <div class="header__menu__option__icon__bar"></div>
        </div>
      </div>
      <div class="header__menu__separator"></div>
      <div class="header__menu__option__exit">
        <div class="header__menu__option__exit__text">
          {{
            aplicacion.languageSel == "es"
              ? "Configurador clásico"
              : aplicacion.languageSel == "en"
                ? "Classic Configurator"
                : aplicacion.languageSel == "fr"
                  ? "Configurateur classique"
                  : aplicacion.languageSel == "de"
                    ? "Klassischer Konfigurator"
                    : aplicacion.languageSel == "it"
                      ? "Configuratore classico"
                      : ""
          }}
        </div>
        <img @click="$emit('Close')" src="@/assets/Images/Global/Back.svg" alt=""
          class="header__menu__option__exit__image" />
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";

import Coleccion from "@/clases/Coleccion.js";

export default {
  name: "Header",
  props: {
    aplicacion: Object,
    aplicacionEstandar: Object,
    aplicacionConfigurable: Object,
    Language: String,
    Coleccion: Object,
    Options: Array,
    DarkMode: Object,
    Hotspots: Object,
    Zoom: Object,
    FullScreen: Object,
    Zoom: Boolean,
    privada: String,
  },
  data() {
    return {
      Open: false,
      extension: "webp",
      separador: "&",
      separador2: "-",
      nImagenes: 0,
      Stored: {
        Comparador: false,
        Zoom: false,
      },
    };
  },
  methods: {
    SetEsError(Status) {
      if (Status) {
        if (this.Comparador) {
          this.$emit("Comparador", false);
          this.Stored.Comparador = true;
        }
        if (this.Zoom) {
          var Zoom;
          if (window.location.href.includes("8081")) {
            Zoom = document.getElementsByClassName("buttons__item")[0];
          } else {
            Zoom = document
              .querySelector("c-selector")
              .shadowRoot.querySelector(".buttons__item");
          }
          this.Stored.Zoom = true;
          Zoom.click();
        }
      } else {
        if (this.Stored.Comparador) {
          this.$emit("Comparador", true);
          this.Stored.Comparador = false;
        }
        if (this.Stored.Zoom) {
          var Zoom;
          if (window.location.href.includes("8081")) {
            Zoom = document.getElementsByClassName("buttons__item")[0];
          } else {
            Zoom = document
              .querySelector("c-selector")
              .shadowRoot.querySelector(".buttons__item");
          }
          this.Stored.Zoom = false;
          Zoom.click();
        }
      }
      return Status;
    },
    DEBUGColeccion(aplicacion) {
      var caracteristicas = aplicacion.datosEstandar.caracteristicas;
      var corresp = aplicacion.datos3Drender.estandar;
      var relacion;
      var campoCod;
      var campo;
      var valores;
      var acabado;
      var mensaje = [];

      var campoCar;
      mensaje = [];
      aplicacion.coleccionSel.sideSel.Live.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          campoCar = campo.cod;
          relacion = corresp.filter((linea) => linea.campo == campoCar);
          if (relacion.length >= 1) {
            campoCar = relacion[0].estandar;
          }
          if (caracteristicas[campoCar.toLowerCase()] != undefined) {
            mensaje.push({ campo: campo.cod, caracteristica: campoCar });
          } else {
            mensaje.push({ campo: campo.cod, caracteristica: null });
          }
        });
      });
      //console.table(mensaje);

      mensaje = [];
      for (const clave in caracteristicas) {
        if (caracteristicas.hasOwnProperty(clave)) {
          const caracteristica = caracteristicas[clave];
          campoCod = clave;
          relacion = corresp.filter((linea) => linea.estandar == campoCod);
          if (relacion.length >= 1) {
            campoCod = relacion[0].campo;
          }
          campo = aplicacion.coleccionSel.sideSel.Live.GetCampo(campoCod);
          if (campo != undefined) {
            mensaje.push({
              caracteristica: " --- " + clave + " --- ",
              campo: campo.cod,
            });

            valores = caracteristica.valores;
            let filtro;
            campo.acabados.forEach((acabado) => {
              filtro = valores.filter((valor) => valor.value == acabado.cod);
              if (filtro.length == 1) {
                mensaje.push({
                  caracteristica: filtro[0].value + ": " + filtro[0].text,
                  campo: acabado.cod + ": " + acabado.GetLiteral("es"),
                });
              } else {
                mensaje.push({
                  caracteristica: null,
                  campo: acabado.cod + ": " + acabado.GetLiteral("es"),
                });
              }
            });
            valores.forEach((valor) => {
              if (
                campo.acabados.findIndex(
                  (acabado) => acabado.cod == valor.value
                ) < 0
              ) {
                mensaje.push({
                  caracteristica: valor.value + ": " + valor.text,
                  campo: null,
                });
              }
            });
          } else {
            mensaje.push({
              caracteristica: " --- " + clave + " --- ",
              campo: null,
            });
          }
        }
      }
      //console.table(mensaje);
    },
    GetCodigoEstandar(aplicacion) {
      var caracteristicas = aplicacion.datosEstandar.caracteristicas;
      var codigos = aplicacion.datosEstandar.codigos;
      var corresp = aplicacion.datos3Drender.estandar;
      var relacion;
      var campoCod;
      var campo, campo2;
      var error = false;
      var sentencia = "";
      var seleccion, seleccion2;
      var retorno;
      var filtro;

      //console.log(caracteristicas);
      for (const clave in caracteristicas) {
        if (caracteristicas.hasOwnProperty(clave)) {
          if (clave == "vidrio") {
            // Los campos  TIPO_VIDRIO y DECORADO van en un única característica: vidrio
            campo =
              aplicacion.coleccionSel.sideSel.Live.GetCampo("TIPO_VIDRIO");
            campo2 = aplicacion.coleccionSel.sideSel.Live.GetCampo("DECORADO");
            seleccion = campo.acabadoSel.cod;
            seleccion2 = campo2.acabadoSel.cod;
            if (seleccion == "01") {
              sentencia += "linea." + clave + " == " + "'0'" + " && ";
            } else if (seleccion == "04") {
              if (!isNaN(parseInt(campo2.acabadoSel.cod))) {
                seleccion2 = campo2.acabadoSel.cod.replace(/^0+(?=[1-9])/, "");
              } else {
                seleccion2 = campo2.acabadoSel.cod;
              }

              sentencia +=
                "linea." + clave + " == " + "'" + seleccion2 + "'" + " && ";
            }
            //console.log(sentencia);
          } else {
            // CASO GENERAL
            relacion = corresp.filter((linea) => linea.estandar == clave);
            if (relacion.length >= 1) {
              campoCod = relacion[0].campo;
            } else {
              campoCod = clave.toUpperCase();
            }
            campo = aplicacion.coleccionSel.sideSel.Live.GetCampo(campoCod);
            if (campo != undefined) {
              if (campo.acabadoSel != undefined) {
                if (!isNaN(parseInt(campo.acabadoSel.cod))) {
                  seleccion = campo.acabadoSel.cod.replace(/^0+(?=[1-9])/, "");
                } else {
                  seleccion = campo.acabadoSel.cod;
                }
              } else {
                seleccion = campo.value;
              }
              sentencia +=
                "linea." + clave + " == " + "'" + seleccion + "'" + " && ";
            } else {
              error = true;
            }
          }
        }
      }

      if (error) {
        //console.log("Error al obtener el código");
        retorno = "ERROR";
      } else {
        sentencia = sentencia.slice(0, -4);
        //console.log(sentencia);

        filtro = codigos.filter((linea) => {
          return eval(sentencia);
        });
        if (filtro.length === 1) {
          retorno = filtro[0].codigo;
        } else {
          retorno = "ERROR";
        }
      }
      return retorno;
    },
    TransformaCampo(campo) {
      let cod = campo.cod;
      if (campo.visual) {
        let conv = this.aplicacion.datos3Drender.estandar.filter(
          (linea) => linea.estandar == campo.cod
        );
        if (conv.length > 0) {
          cod = conv[0].campo;
        }
      }
      return cod;
    },
    TransformaAcabado(acabadoCod) {
      let cod;
      if (!isNaN(parseInt(acabadoCod))) {
        cod = acabadoCod.padStart(2, "0");
      } else {
        cod = acabadoCod;
      }
      return cod;
    },
    ExportExcel() {
      var expEstandar = [];
      var expConfigurable = [];
      var expCapas = [];
      var expDiferencia = [];
      var workbook = XLSX.utils.book_new();
      var sheet;
      var that = this;

      function OrdenaYFormula(capas) {
        // Ordenas las filas con las que se crea la excel
        capas = capas.sort(function (a, b) {
          // Ordenar por visual='SI' (primero los 'SI', luego los 'NO' o nulos)
          if (a[2] === "SI" && b[2] !== "SI") return -1;
          if (a[2] !== "SI" && b[2] === "SI") return 1;
          // Ordenar por acabado != nulo (primero los que tienen acabado, luego los nulos)
          if (a[4] !== "" && b[4] === "") return -1;
          if (a[4] === "" && b[4] !== "") return 1;
          // Ordenar por tipo,
          if (a[1] < b[1]) return -1;
          if (a[1] > b[1]) return 1;
          // luego por campo,
          if (a[3] < b[3]) return -1;
          if (a[3] > b[3]) return 1;
          // y por acabado
          if (a[4] < b[4]) return -1;
          if (a[4] > b[4]) return 1;
          // Si ninguno de los casos anteriores aplica, mantener el orden actual
          return 0;
        });
        // Rehace las formulas para las capas
        // Añade las formulas de la imagen (una vez ya está ordenado, esto es  por el índice de la formula: A1, A2, etc.)
        var formulaArchivo;
        for (let i = 0; i < capas.length; i++) {
          if (capas[i][2] == "SI") {
            formulaArchivo =
              "CONCATENATE(A" +
              (i + 2) +
              ',"' +
              that.separador +
              '",B' +
              (i + 2) +
              ',"' +
              that.separador +
              '",D' +
              (i + 2) +
              ',"' +
              that.separador +
              '",E' +
              (i + 2) +
              "," +
              "IF(G" +
              (i + 2) +
              '="","",' +
              'CONCATENATE("' +
              that.separador +
              '",' +
              "G" +
              (i + 2) +
              "))" +
              ")";
            capas[i][7] = { v: "", t: "s", f: formulaArchivo };
          }
        }

        return capas;
      }

      if (Object.keys(this.aplicacionConfigurable).length > 0) {
        expConfigurable = this.Export(this.aplicacionConfigurable);
        expConfigurable = OrdenaYFormula(expConfigurable);
        //console.log("configurable", expConfigurable);
      }
      if (Object.keys(this.aplicacionEstandar).length > 0) {
        expEstandar = this.Export(this.aplicacionEstandar);
        expEstandar = OrdenaYFormula(expEstandar);
        //console.log("estandar", expEstandar);
      }

      if (expConfigurable.length > 0 && expEstandar.length > 0) {
        expEstandar.forEach((estandar) => {
          if (estandar[2] == "SI") {
            if (
              expConfigurable.filter(
                (configurable) =>
                  estandar[0] == configurable[0] &&
                  estandar[1] == configurable[1] &&
                  estandar[2] == configurable[2] &&
                  estandar[3] == configurable[3] &&
                  estandar[4] == configurable[4]
              ).length <= 0
            ) {
              expDiferencia.push(estandar);
            }
          }
        });
        expCapas = expConfigurable.concat(expDiferencia);
        expCapas = OrdenaYFormula(expCapas);
        //console.log("exCapas", expCapas);
        //console.log("expDiferencia", expDiferencia);
      } else if (expConfigurable.length > 0) {
        expCapas = expCapas.concat(expConfigurable);
      } else if (expEstandar.length > 0) {
        expCapas = expCapas.concat(expEstandar);
      }

      if (expCapas.length > 0) {
        expCapas.unshift([
          "coleccion",
          "tipo",
          "visual",
          "caracteristica",
          "valor",
          "texto",
          "capa",
          "imagen",
        ]);
        sheet = XLSX.utils.aoa_to_sheet(expCapas);
        XLSX.utils.book_append_sheet(workbook, sheet, "capas");
      }
      if (expConfigurable.length > 0) {
        expConfigurable.unshift([
          "coleccion",
          "tipo",
          "visual",
          "caracteristica",
          "valor",
          "texto",
          "capa",
          "imagen",
        ]);
        sheet = XLSX.utils.aoa_to_sheet(expConfigurable);
        XLSX.utils.book_append_sheet(workbook, sheet, "configurable");
      }
      if (expEstandar.length > 0) {
        expEstandar.unshift([
          "coleccion",
          "tipo",
          "visual",
          "caracteristica",
          "valor",
          "texto",
          "capa",
          "imagen",
        ]);
        sheet = XLSX.utils.aoa_to_sheet(expEstandar);
        XLSX.utils.book_append_sheet(workbook, sheet, "estandar");
      }

      //Exporta la excel
      let now = new Date();

      XLSX.writeFile(
        workbook,
        this.aplicacion.colecciones[0].cod +
        "_" +
        now.getFullYear() +
        "_" +
        (now.getMonth() + 1) +
        "_" +
        now.getDate() +
        "_" +
        now.getHours() +
        "_" +
        now.getMinutes() +
        "_" +
        now.getSeconds() +
        ".xlsx"
      );

      this.$emit("ExportData");
    },
    Export(aplicacion) {
      var exportacion;
      var acabados = [];
      var nImagenes;
      var capa;
      var language = aplicacion.languageSel;

      function NImagenes(coleccion, campo) {
        var ret = 1;

        if (campo == "POMO_ST") {
          ret = 2;
        }
        return ret;
      }

      // Recorre el objeto aplicacion
      aplicacion.colecciones.forEach((coleccion) => {
        exportacion = [];
        // Crea cada fila de la excel
        coleccion.sides[0].grupos.forEach((grupo) => {
          grupo.campos.forEach((campo) => {
            // Campos cuya imagen está compuesta con otro campo

            if (campo.cod == "vidrio") {
              // Capas de TIPO_VIDRIO con PARED
              let campoCod = "TIPO_VIDRIO";
              var campoCompuestoCod = "PARED";
              var campoCompuesto = coleccion.sides[0].GetCampo("PARED");
              var centinela = false;
              for (let i = 0; i < campo.acabados.length; i++) {
                let acabadoCod;
                if (
                  campo.acabados[i].cod == "0" ||
                  campo.acabados[i].cod == "00"
                ) {
                  // Incoloro
                  acabadoCod = "01";
                  campoCompuesto.acabados.forEach((acabado) => {
                    exportacion.push([
                      coleccion.cod.toUpperCase(),
                      grupo.cod,
                      campo.visual ? "SI" : "NO",
                      campoCod + "-" + campoCompuestoCod,
                      acabadoCod + "-" + acabado.cod,
                      campo.acabados[i].GetLiteral(language) +
                      "-" +
                      acabado.GetLiteral(language),
                      capa,
                      "",
                    ]);
                  });
                } else if (!centinela) {
                  // Decorado
                  acabadoCod = "04";
                  campoCompuesto.acabados.forEach((acabado) => {
                    exportacion.push([
                      coleccion.cod.toUpperCase(),
                      grupo.cod,
                      campo.visual ? "SI" : "NO",
                      campoCod + "-" + campoCompuestoCod,
                      acabadoCod + "-" + acabado.cod,
                      "DECORADO" + "-" + acabado.GetLiteral(language),
                      capa,
                      "",
                    ]);
                  });
                  centinela = true;
                }
              }
              // Capas de DECORADO
              for (let i = 0; i < campo.acabados.length; i++) {
                if (
                  campo.acabados[i].cod != "0" &&
                  campo.acabados[i].cod != "00"
                ) {
                  // Decorados
                  let acabadoCod = this.TransformaAcabado(
                    campo.acabados[i].cod
                  );
                  exportacion.push([
                    coleccion.cod.toUpperCase(),
                    grupo.cod,
                    campo.visual ? "SI" : "NO",
                    "DECORADO" + "-" + "COLOR_DECORADO",
                    acabadoCod + "-" + "01", // blanco
                    campo.acabados[i].GetLiteral(language) + "-" + "Blanco", // blanco
                    capa,
                    "",
                  ]);
                }
              }
            } else if (campo.cod == "COLOR_DECORADO") {
              // Obvia el campo COLOR_DECORADO
            } else if (campo.compuesto != undefined) {
              let campoCod = this.TransformaCampo(campo);
              let campoCompuestoCod = this.TransformaCampo(campo.compuesto);
              // HARDCODE 2: Imágenes dobles
              nImagenes = NImagenes(coleccion.cod, campo.cod);
              // HARDCODE 2: Imágenes dobles
              for (let nImagen = 1; nImagen <= nImagenes; nImagen++) {
                if (nImagenes > 1) {
                  capa = nImagen;
                } else {
                  capa = "";
                }
                for (let i = 0; i < campo.acabados.length; i++) {
                  aplicacion.coleccionSel.sideSel.Live.perfil[
                    campo.cod.toLowerCase()
                  ].value = campo.acabados[i].cod;
                  acabados = campo.compuesto.GetAcabadosValidos(
                    aplicacion.coleccionSel.sideSel.Live.perfil
                  );
                  for (let j = 0; j < acabados.length; j++) {
                    let acabadoCod = this.TransformaAcabado(
                      campo.acabados[i].cod
                    );
                    let acabadoCompuestoCod = this.TransformaAcabado(
                      acabados[j].cod
                    );
                    exportacion.push([
                      coleccion.cod.toUpperCase(),
                      grupo.cod,
                      campo.visual ? "SI" : "NO",
                      campoCod + "-" + campoCompuestoCod,
                      acabadoCod + "-" + acabadoCompuestoCod,
                      campo.acabados[i].GetLiteral(language) +
                      "-" +
                      acabados[j].GetLiteral(language),
                      capa,
                      "",
                    ]);
                  }
                }
              }
            } else {
              let campoCod = this.TransformaCampo(campo);
              if (campo.acabados.length > 0) {
                for (let i = 0; i < campo.acabados.length; i++) {
                  let acabadoCod = campo.acabados[i].cod;
                  acabadoCod = this.TransformaAcabado(campo.acabados[i].cod);
                  if (campo.acabados[i].compuesto == null) {
                    exportacion.push([
                      coleccion.cod.toUpperCase(),
                      grupo.cod,
                      campo.visual ? "SI" : "NO",
                      campoCod,
                      acabadoCod,
                      campo.acabados[i].GetLiteral(language),
                      "",
                      "",
                    ]);
                  } else {
                    let campoCompuestoCod = this.TransformaCampo(
                      campo.acabados[i].compuesto
                    );
                    for (
                      let j = 0;
                      j < campo.acabados[i].compuesto.acabados.length;
                      j++
                    ) {
                      let acabadoCompuestoCod = this.TransformaAcabado(
                        campo.acabados[i].compuesto.acabados[j].cod
                      );
                      exportacion.push([
                        coleccion.cod.toUpperCase(),
                        grupo.cod,
                        campo.visual ? "SI" : "NO",
                        campoCod + "-" + campoCompuestoCod,
                        acabadoCod + "-" + acabadoCompuestoCod,
                        campo.acabados[i].GetLiteral(language) +
                        "-" +
                        campo.acabados[i].compuesto.acabados[j].GetLiteral(
                          language
                        ),
                        "",
                        "",
                      ]);
                    }
                  }
                }
              } else {
                exportacion.push([
                  coleccion.cod.toUpperCase(),
                  grupo.cod,
                  campo.visual ? "SI" : "NO",
                  campo.cod,
                  "",
                  "",
                  "",
                  "",
                ]);
              }
            }
          });
        });
      });

      return exportacion;
    },
    ExportTacos(aplicacion) {
      var exportacion;
      var workbook = XLSX.utils.book_new();
      var sheet;
      var formulaImagen;

      // Recorre el objeto aplicacion
      aplicacion.colecciones.forEach((coleccion) => {
        exportacion = [];
        // Crea cada fila de la excel
        coleccion.sides[0].grupos.forEach((grupo) => {
          grupo.campos.forEach((campo) => {
            if (campo.acabados.length > 0 && campo.visual) {
              for (let i = 0; i < campo.acabados.length; i++) {
                exportacion.push([
                  coleccion.cod.toUpperCase(),
                  campo.cod,
                  campo.acabados[i].cod,
                  campo.acabados[i].GetLiteral(language),
                  "",
                ]);
              }
            }
          });
        });

        // Añade las formulas de la imagen (una vez ya está ordenado, esto es  por el índice de la formula: A1, A2, etc.)
        for (let i = 0; i < exportacion.length; i++) {
          formulaImagen =
            "CONCATENATE(B" +
            (i + 2) +
            ',"' +
            this.separador +
            '",C' +
            (i + 2) +
            ',".' +
            this.extension +
            '")';
          exportacion[i][4] = { v: "", t: "s", f: formulaImagen };
        }
        // Añade los títulos de las columnas
        exportacion.unshift([
          "coleccion",
          "caracteristica",
          "valor",
          "texto",
          "taco",
        ]);

        // Genera la hoja y la añade a la excel
        sheet = XLSX.utils.aoa_to_sheet(exportacion);
        XLSX.utils.book_append_sheet(workbook, sheet, coleccion.cod);
        //console.log(exportacion);
      });

      //Exporta la excel
      let now = new Date();
      if (aplicacion.colecciones.length > 1) {
        XLSX.writeFile(
          workbook,
          "tacos " +
          now.getFullYear() +
          "_" +
          (now.getMonth() + 1) +
          "_" +
          now.getDate() +
          "_" +
          now.getHours() +
          "_" +
          now.getMinutes() +
          "_" +
          now.getSeconds() +
          ".xlsx"
        );
      } else {
        XLSX.writeFile(
          workbook,
          aplicacion.colecciones[0].cod +
          " tacos " +
          now.getFullYear() +
          "_" +
          (now.getMonth() + 1) +
          "_" +
          now.getDate() +
          "_" +
          now.getHours() +
          "_" +
          now.getMinutes() +
          "_" +
          now.getSeconds() +
          ".xlsx"
        );
      }
    },
    ResolveImage(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      element.style.opacity = 1;
    },
    SetOption(e, Object) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }
      switch (Object.cod) {
        case "Share":
          this.$emit("Share");
          break;
        case "DarkMode":
          element.style.opacity = 0;
          element.parentNode.children[1].children[0].style.opacity = 0;
          this.$emit("DarkMode", !this.DarkMode.Live);
          setTimeout(() => {
            element.parentNode.children[1].children[0].style.opacity = 1;
          }, 350);
          break;
        case "Hotspots":
          element.style.opacity = 0;
          element.parentNode.children[1].children[0].style.opacity = 0;
          this.$emit("Hotspots", !this.Hotspots.Live);
          if (this.Zoom) {
            this.$emit("Zoom", false);
          }
          setTimeout(() => {
            element.parentNode.children[1].children[0].style.opacity = 1;
          }, 350);
          break;
        case "Zoom":
          element.style.opacity = 0;
          element.parentNode.children[1].children[0].style.opacity = 0;
          this.$emit("Zoom", !this.Zoom.Live);
          setTimeout(() => {
            element.parentNode.children[1].children[0].style.opacity = 1;
          }, 350);
          break;
        case "FullScreen":
          element.style.opacity = 0;
          element.parentNode.children[1].children[0].style.opacity = 0;
          this.$emit("FullScreen", !this.FullScreen.Live);
          var elem = document.body;
          if (
            (document.fullScreenElement !== undefined &&
              document.fullScreenElement === null) ||
            (document.msFullscreenElement !== undefined &&
              document.msFullscreenElement === null) ||
            (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
            (document.webkitIsFullScreen !== undefined &&
              !document.webkitIsFullScreen)
          ) {
            if (elem.requestFullScreen) {
              elem.requestFullScreen();
            } else if (elem.mozRequestFullScreen) {
              elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullScreen) {
              elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            } else if (elem.msRequestFullscreen) {
              elem.msRequestFullscreen();
            }
          } else {
            if (document.cancelFullScreen) {
              document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            }
          }
          setTimeout(() => {
            element.parentNode.children[1].children[0].style.opacity = 1;
          }, 350);
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  width: 100%;
  height: $Header-height;
  padding: 0px 25px;
  background-color: white;
  -webkit-transition: background-color 0.35s ease-in-out;
  -moz-transition: background-color 0.35s ease-in-out;
  -ms-transition: background-color 0.35s ease-in-out;
  -o-transition: background-color 0.35s ease-in-out;
  transition: background-color 0.35s ease-in-out;

  &__info {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    height: 100%;

    &__logo {
      filter: invert(0%) brightness(100%);
      height: 30px;
      -webkit-transition: filter 0.35s ease-in-out;
      -moz-transition: filter 0.35s ease-in-out;
      -ms-transition: filter 0.35s ease-in-out;
      -o-transition: filter 0.35s ease-in-out;
      transition: filter 0.35s ease-in-out;
    }

    &__collection {
      text-transform: capitalize;
      color: black;
      font-size: 25px;
      line-height: 25px;
      font-weight: 400;
      text-transform: capitalize;
      -webkit-transition: color 0.35s ease-in-out;
      -moz-transition: color 0.35s ease-in-out;
      -ms-transition: color 0.35s ease-in-out;
      -o-transition: color 0.35s ease-in-out;
      transition: color 0.35s ease-in-out;
    }

    &__configuration {
      @media screen and (max-width: 650px) {
        display: none;
      }

      text-transform: capitalize;
      color: black;
      font-size: 18px;
      line-height: 25px;
      margin-top: 5px;
      font-weight: 400;
      margin-left: 20px;
      text-transform: capitalize;
      -webkit-transition: color 0.35s ease-in-out;
      -moz-transition: color 0.35s ease-in-out;
      -ms-transition: color 0.35s ease-in-out;
      -o-transition: color 0.35s ease-in-out;
      transition: color 0.35s ease-in-out;
    }

    &__separator {
      pointer-events: none;
      height: 40%;
      width: 0.1em;
      background-color: black;
      margin: 0px 15px;
      -webkit-transition: background-color 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out;
    }
  }

  &__menu {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    height: 100%;

    &__option {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      align-content: center;
      height: 100%;

      &__items {
        opacity: 1;
        position: absolute;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        right: 60px;
        top: 13px;
        -webkit-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
          top 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
          top 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
          top 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
          top 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
          top 0.35s ease-in-out;

        &__item {
          opacity: 1;
          background-color: transparent;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          align-content: center;
          height: 100%;
          -webkit-transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out,
            opacity 0.35s ease-in-out;

          &__option {
            position: relative;

            &__image {
              filter: invert(0%);
              opacity: 1;
              cursor: pointer;
              width: 24px;
              height: 24px;
              object-fit: cover;
              -webkit-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            }

            &__name {
              filter: invert(0%);
              opacity: 0;
              z-index: 1000;
              pointer-events: none;
              position: absolute;
              right: 0px;
              top: 30px;
              white-space: nowrap;
              background-color: black;
              color: white;
              font-size: 10px;
              line-height: 10px;
              padding: 4px 14px;
              -webkit-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;

              & p {
                opacity: 1;
                -webkit-transition: opacity 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out;
              }
            }

            &:hover {
              & .header__menu__option__items__item__option {
                &__name {
                  opacity: 1;
                  -webkit-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                }
              }
            }
          }

          &:not(:first-child) {
            margin-left: 21px;
          }

          &.hidden {
            pointer-events: none;

            & .header__menu__option__items__item {
              &__option {
                &__image {
                  opacity: 0.2 !important;
                  -webkit-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                }
              }
            }
          }
        }

        &.hidden {
          opacity: 0;
          pointer-events: none;
          right: -160px;
          -webkit-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
        }
      }

      &__save {
        position: relative;

        &__name {
          filter: invert(0%);
          opacity: 0;
          z-index: 1000;
          pointer-events: none;
          position: absolute;
          right: 0px;
          top: 30px;
          white-space: nowrap;
          background-color: black;
          color: white;
          font-size: 10px;
          line-height: 10px;
          padding: 4px 14px;
          -webkit-transition: opacity 0.35s ease-in-out,
            filter 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        }

        &:hover {
          & .header__menu__option__save {
            &__name {
              opacity: 1;
              -webkit-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            }
          }
        }
      }

      &__icon {
        filter: invert(0%);
        cursor: pointer;
        width: 24px;
        height: 24px;
        object-fit: cover;
        -webkit-transition: filter 0.35s ease-in-out;
        -moz-transition: filter 0.35s ease-in-out;
        -ms-transition: filter 0.35s ease-in-out;
        -o-transition: filter 0.35s ease-in-out;
        transition: filter 0.35s ease-in-out;

        &__bar {
          transform: none;
          width: 85%;
          height: 0.1em;
          background-color: black;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
        }

        &.hamburguer {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          align-items: center;
          align-content: center;
          height: 45%;
        }

        &.open {
          & .header__menu__option__icon__bar {
            &:nth-child(1) {
              transform: translate(0, 6px) rotate(-45deg);
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }

            &:nth-child(2) {
              opacity: 0;
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }

            &:nth-child(3) {
              transform: translate(0, -6px) rotate(45deg);
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }
          }
        }

        &.hover {
          opacity: 1;
          -webkit-transition: all 0.35s ease-in-out;
          -moz-transition: all 0.35s ease-in-out;
          -ms-transition: all 0.35s ease-in-out;
          -o-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;

          &:hover {
            opacity: 0.35;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;
          }
        }
      }

      &__exit {
        filter: invert(0%);
        position: relative;
        width: 24px;
        height: 24px;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;

        &__text {
          position: absolute;
          right: 0;
          top: 30px;
          z-index: 10000;
          filter: invert(0%);
          opacity: 0;
          pointer-events: none;
          background-color: black;
          color: white;
          font-size: 10px;
          line-height: 10px;
          padding: 4px 14px;
          white-space: nowrap;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }

        &__image {
          filter: invert(0%);
          cursor: pointer;
          width: 24px;
          height: 24px;
          object-fit: cover;
          -webkit-transition: filter 0.35s ease-in-out;
          -moz-transition: filter 0.35s ease-in-out;
          -ms-transition: filter 0.35s ease-in-out;
          -o-transition: filter 0.35s ease-in-out;
          transition: filter 0.35s ease-in-out;
        }

        &:hover {
          & .header__menu__option__exit {
            &__text {
              opacity: 1;
              -webkit-transition: opacity 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out;
            }
          }
        }
      }
    }

    &__separator {
      pointer-events: none;
      height: 40%;
      width: 0.1em;
      background-color: black;
      margin: 0px 12px;
      -webkit-transition: background-color 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out;
    }
  }

  @media screen and (max-width: 950px) and (min-height: 600px) {
    @media screen and (max-width: 350px) {
      padding: 0px 15px;
    }

    &__menu {
      &__option {
        position: revert;

        &__items {
          opacity: 1;
          justify-content: space-evenly;
          right: 0px;
          top: 50px;
          width: 100dvw;
          z-index: 9999999;
          -webkit-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
            top 0.35s ease-in-out;

          &__item {
            width: 100%;
            height: 75px;
            margin-left: 0px !important;
            background-color: #f3f4f6;
            -webkit-transition: background-color 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out;

            &__option {
              &__image {
                height: 40px;
                width: 40px;

                @media screen and (max-width: 350px) {
                  height: 30px;
                  width: 30px;
                }
              }

              &__name {
                display: none;
              }
            }

            &:not(:first-child) {
              border-left: 1px solid grey;
            }

            &:nth-child(3) {
              pointer-events: none;

              & .header__menu__option__items__item {
                &__option {
                  &__image {
                    opacity: 0.2 !important;
                  }
                }
              }
            }
          }

          &.hidden {
            opacity: 0;
            right: 0px;
            pointer-events: none;
            -webkit-transition: opacity 0.35s ease-in-out,
              right 0.35s ease-in-out, top 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
              top 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
              top 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
              top 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out, right 0.35s ease-in-out,
              top 0.35s ease-in-out;
          }
        }
      }
    }
  }

  @media screen and (max-height: 600px) {
    &__menu {
      &__option {
        &__items {
          &__item {
            &__option {
              &__name {
                display: none;
              }
            }

            &:nth-child(3) {
              pointer-events: none;

              & .header__menu__option__items__item {
                &__option {
                  &__image {
                    opacity: 0.2 !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
